export default () => {
  return (
    <div className="rosads">
      <div className="col-md-12">
        <div className="googls-adds">
          <div className="CMSBanner Banner gadsbanner" id="div-gpt-ad-1628625252827-0" style={{ minWidth: 300, minHeight: 250, margin: "9px auto", padding: "0 .2px", display: 'none' }}></div>
          <div className="CMSBanner Banner gadsbanner" id="div-gpt-ad-1628625323242-0" style={{ minWidth: 300, minHeight: 250, margin: "9px auto", padding: "0 .2px", display: 'none' }}></div>
          <div className="CMSBanner Banner gadsbanner" id="div-gpt-ad-1628625359907-0" style={{ minWidth: 300, minHeight: 250, margin: "9px auto", padding: "0 .2px", display: 'none' }}></div>
          <div className="CMSBanner Banner gadsbanner" id="div-gpt-ad-1628625430383-0" style={{ minWidth: 300, minHeight: 250, margin: "9px auto", padding: "0 .2px", display: 'none' }}></div>
        </div>
      </div>
    </div>
  );
};
